//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    data() {
      return {
        tabActive: 1,
        loading: false,
        imgNull: require("@/assets/image/icon/icon_null.png"),
        iconSound: require("@/assets/image/icon/icon_sound.png"),
        active: 0,
        menuIdx: 0,
        isLogin: true,
        showBuyDialog: false,
        buyItem: {},
        columnConfig: [
          {
            //电子书
            objType: "media",
            columnCode: "ebook",
            mediaType: "ebook",
            title: this.$t("PURCHASE_LANG.menu.3"),
          },
          {
            //有声书
            objType: "medialist",
            columnCode: "audio",
            mediaType: "audio",
            title: this.$t("PURCHASE_LANG.menu.2"),
          },
          {
            //课程
            objType: "medialist",
            columnCode: "course",
            mediaType: "audio",
            title: this.$t("PURCHASE_LANG.menu.1"),
          },
          {
            //讲书
            objType: "medialist",
            columnCode: "talk_book",
            mediaType: "audio",
            title: this.$t("PURCHASE_LANG.menu.0"),
          },
        ],
        listD: {
          ebook: [],
          audio: [],
          course: [],
          talk_book: [],
        },
        targetL: {
          //跳轉地址配置
          column: {
            path: "detail",
            params: [{ name: "objId", label: "id"}] //跳轉所需參數
          },
          video: {
            path: "videoDetail",
            params: [{ name: "objId", label: "id"}]
          },
          audio: {
            path: "audioDetail",
            params: [{ name: "objId", label: "id"}]
          },
          ebook: {
            path: "ebookDetail",
            params: [{ name: "objId", label: "id"}]
          }
        }
      };
    },
    methods: {
      changeMenu(idx) {
        this.menuIdx = idx;
        let item = this.columnConfig[idx];

        // let data = {
        //   key: "purchaseIndex",
        //   value: idx.toString(),
        // };
        //native.setStorage(JSON.stringify(data));

        this.getData(item);
      },
      getData(obj) {

        this.LOGIN2.getSession("no login")
          .then((returnSession) => {
            // 有session
            console.log("session", returnSession);

            let postD = {
              userIds: returnSession.userId,
              pageNo: 1,
              pageSize: 999, //暫不實現分頁
              //objType: obj.objType,
              columnCodes: obj.columnCode,
              //mediaType: obj.mediaType,
            };

            this.$toast.loading();
            this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.ORDER.BUYLIST, postD, "POST", "no login", false, "set storage")
              .then((res) => {
                //console.log("res", res);
                this.$toast.close();
                this.isLogin = true;

                if (res.rows.length > 0) {
                  this.listD[obj.columnCode] = res.rows;
                } else {
                  //判斷空
                  this.listD[obj.columnCode] = [];
                }
              })
              .catch((err) => {
                if (err.response.data.code != 401) {
                  this.toast.text(err.response.data.message);
                }
              });
          })
          .catch((err) => {
            //沒有session
            this.listD = {
              talk_book: [],
              course: [],
              audio: [],
              ebook: [],
            };

            this.isLogin = false;
          });

      },
      gotoTarget(item,index) {
        //let item = this.listD[index];

        let types = item.objType; //类型
        let target = this.targetL[types];
        if(types == 'medialist'){
          target = this.targetL['column'];
        }else{
          target = this.targetL['ebook'];
        }
        if (target == undefined) {
          //未配置的目標地址
          // console.log("error", "未配置的目標地址");
          return;
        }
        let pArr = target.params;
        let q = {};
        let obj = {};
        obj["path"] = this.UTILS.splitUrl(target.path);
        pArr.forEach(p => {
          let val = item[p.name];
          //如果有傳入LABLE則，使用LABEL作為屬性值，沒有則使用name作為參數值
          let key = p.label ? p.label : p.name;
          q[key] = val;
        });
        obj["query"] = q;
        obj["router"] = this.$router;
        this.GLOBAL_.ccApp.openTo(obj);
      },
      goLogin(){
        //打開登入界面
        let obj = {
          router: this.$router,
          path: this.UTILS.splitUrl("login"),
          isTransWindows: true
        };
        this.GLOBAL_.ccApp.openTo(obj);
      }
    },
    mounted() {
      this.getData(this.columnConfig[0]);
    }
  };



// WEBPACK FOOTER //
// ./src/pages/myBook.vue